// src/App.js
import React, { useEffect } from 'react';
import { Route, Routes, useNavigate  } from 'react-router-dom';
import Sidebar from './Components/Sidebar';
import All_Routes from './Components/All_Routes';
import useIdleLogout from './Components/Ideal_Logout';

import './App.css';

const App = () => {
  useIdleLogout();  // Logout after 2 hour inactivity
  const navigate = useNavigate();
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (!isLoggedIn) {
      navigate('/');
    }
  }, [navigate]); 

  return (
      <div className="d-flex">
        <Sidebar />
        <div className="container">
          <Routes>
              {All_Routes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
          </Routes>
        </div>
      </div>
  );
};

export default App;
